import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Select from "react-select";
import { apiService } from "service/ApiService";
import { notificationService } from "service/NotificationService";
import StoreContext from "contexts/StoreContext";

import { useTranslation } from "react-i18next";

export default function CopyExtraCategoryModal({ extraCategoryId, extraCategoryName, show, handleClose }) {
  const {
    t,
  } = useTranslation();

  const { storeId } = useContext(StoreContext);
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [isCopying, setIsCopying] = useState(false);

  useEffect(() => {
    if (!show) return;
    apiService
      .get("api/v1/stores")
      .then((response) => {
        setStores(response.data.filter((store) => store.id !== storeId).map((store) => ({ value: store.id, label: store.name })));
      })
      .catch((error) => {
        console.error(error);
        notificationService.notifyError(error.message);
      });
  }, [show, storeId]);

  const copy = () => {
    setIsCopying(true);
    apiService
      .postJson(`api/v1/extra-categories/${extraCategoryId}/copy`, { storeId: selectedStore.value })
      .then(() => {
        notificationService.notifySuccess(t("messages.extraCategoryCopiedSuccessfully"));
        setIsCopying(false);
        handleClose();
      })
      .catch((error) => {
        console.error(error);
        notificationService.notifyError(t("messages.unableToCopyExtraCategory"));
        setIsCopying(false);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} onExited={() => setSelectedStore(null)} aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ margin: 0 }}>
          {t("pages.titles.copyExtraCategory")}
          {extraCategoryName ? `: ${extraCategoryName}` : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted">{t("messages.selectTheStoreToCopyTheExtraCategoryTo")}</p>
        <Form.Group>
          <label>{t("common.labels.store")}</label>
          <Select
            styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
            isDisabled={isCopying}
            className="primary"
            name="copyStoreSelect"
            onChange={setSelectedStore}
            value={selectedStore}
            options={stores}
            noOptionsMessage={() => t("messages.noStoresAreAvailable")}
            placeholder={t("forms.placeholders.selectStore")}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="default" onClick={handleClose} disabled={isCopying}>
          {t("common.actions.cancel")}
        </Button>
        <Button className="btn-wd btn-outline" variant="success" onClick={copy} disabled={!selectedStore || isCopying}>
          {isCopying ? (
            <div>
              <i className="fa fa-circle-notch fa-spin"></i>
              <span>{t("messages.pleaseWait")}</span>
            </div>
          ) : (
            <div>
              <i className="fa fa-copy" />
              <span>{t("common.actions.copy")}</span>
            </div>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
